// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NyjT1","colBig":"styles_colBig__eNPCA","colSmall":"styles_colSmall__2ybho","shopifyNameWrapper":"styles_shopifyNameWrapper__kNL-N"};